import { proxy } from "valtio"
import { subscribeKey } from "valtio/utils"
import { sessionStore } from "./session.store"
import { appStore } from "./app.store"
import { userStore } from "./user.store"
import { scenarioStore } from "./scenario.store"
import { templateStore } from "./template.store"
import { credentialStore } from "./credential.store"

export const store = proxy({
  app: appStore,
  session: sessionStore,
  scenario: scenarioStore,
  template: templateStore,
  credential: credentialStore,
  user: userStore,
})

subscribeKey(store, "session", (v) => {
  const { actions, ...state } = v
  localStorage.setItem("session", JSON.stringify(state))
})

export type StoreName = keyof typeof store
